import { render } from "./LocalizationBox.vue?vue&type=template&id=27671c91"
import script from "./LocalizationBox.vue?vue&type=script&lang=js"
export * from "./LocalizationBox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__